import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import { publish } from '@jutro/events';
export const getFromArray = (array, value, defaultValue) => _includesInstanceProperty(array).call(array, value) ? value : defaultValue;
export function trackMethod(callback, topic, payload) {
  return (...args) => {
    if (callback) {
      callback(...args);
    }
    publish(topic, payload);
  };
}